import React from 'react';
import { Layout as AntdLayout } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { scVarTransitionDuration } from '@utils/emotion/variables';

import ThemedLogo from '../UIKit/ThemedLogo';
import { useUIStore } from '@stores/ui';

const { Header: AntdHeader, Sider: AntdSider } = AntdLayout;

const ContainerSkeleton: React.FC = () => {
  const { isSiderCollapsed } = useUIStore();

  return (
    <SkeletonLayout>
      <SkeletonSider collapsible collapsed={isSiderCollapsed} trigger={null} width={256}>
        <div className="minimal-area" />
      </SkeletonSider>
      <SkeletonLayout>
        <SkeletonHeader>
          <h1 className="logo">
            <ThemedLogo />
          </h1>
        </SkeletonHeader>
        <SkeletonContent>
          <LoadingOutlined style={{ fontSize: '48px' }} />
        </SkeletonContent>
      </SkeletonLayout>
    </SkeletonLayout>
  );
};

const SkeletonLayout = styled(AntdLayout)`
  background-color: ${({ theme }) => theme.colors.primary.bgColor};
`;

const SkeletonSider = styled(AntdSider)`
  flex: 0 0 240px !important;
  width: 240px !important;
  min-width: 240px !important;
  max-width: 240px !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);

  &.ant-layout-sider-collapsed {
    flex: 0 0 62px !important;
    width: 62px !important;
    min-width: 62px !important;
    max-width: 62px !important;

    .minimal-area {
      background-color: ${({ theme }) => theme.sidebar.minimalBgCollapsedColor};
    }

    .ant-menu {
      width: 30px;

      .ant-menu-item {
        padding: 0 4px 0 30px !important;

        strong {
          opacity: 0;
        }
      }
    }

    .sider-header {
      opacity: 0;
    }
  }

  .minimal-area {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    width: 62px;
    background-color: ${({ theme }) => theme.sidebar.minimalBgColor};
  }

  .ant-layout-sider-children {
    padding: 233px 0 0 62px;
    background-color: ${({ theme }) => theme.sidebar.bgColor};
    color: ${({ theme }) => theme.colors.fontColor};
    transition: background-color ${scVarTransitionDuration} ease,
      color ${scVarTransitionDuration} ease;
  }
`;

const SkeletonHeader = styled(AntdHeader)`
  display: flex;
  height: 56px;
  padding: 0 36px;
  background-color: ${({ theme }) => theme.colors.solid.color};
  color: ${({ theme }) => theme.colors.fontColor};
  line-height: 56px;

  .logo {
    display: flex;
    align-items: center;
    height: 100%;
    margin-right: auto;

    svg {
      display: block;
      width: auto;
      height: 24px;
    }
  }
`;

const SkeletonContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export default ContainerSkeleton;
